<template>
    <BasicModalWindow
      @modalWindowClose="onModalClose()"
      ref="modal_window_component"
      class="contacts-modal"
    >
        <template #title>
            {{Language.say('contacts.modals.to_group_title', [group_selected.name])}}
        </template>

        <template #pre-body>
          <InputSearch
            class="contacts-search"
            @inputSearchSet='onSearchSet'
            @inputSearchClear='onSearchClear'
           />
        </template>

        <template #body>
            <ContactsListCheckbox ref="contacts_list_component"
              :contacts_selection='contacts_selection'
              :contacts_list="contacts_list"
              :disabled_ids="group_selected.members"
            />
        </template>

        <template #footer>
            <ActionButton
                @click="onAddToGroupSubmit()"
                icon="fa fa-folder-open"
                class='main-action push-right'
                text="contacts.actions.add_to_group"
                :loading="false"
                :disabled="!contacts_selection.count"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import {ref, reactive}                           from 'vue';
  import {onBeforeMount, defineProps, defineEmits} from 'vue';
  import ContactsListCheckbox                      from '../Partials/ContactsListCheckbox.vue';
  import ActionButton                              from '@/vue/Elements/Buttons/ActionButton.vue'
  import BasicModalWindow                          from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import InputSearch                               from '@/vue/Elements/Inputs/InputSearch.vue';
  import ContactsSelectionCollection               from '@/js/Contacts/Collections/ContactsSelectionCollection';
  import ContactsFilterCollection                  from '@/js/Contacts/Collections/ContactsFilterCollection';
  import ContactsController                        from '@/js/Contacts/ContactsController';
  import Language                                  from '@/js/Shared/Language/Language.js';

  const props   = defineProps({
    group_selected : {
      required: true,
    }
  })

  const emit = defineEmits([
    'contactsToGroupSubmit', 'contactsToGroupCancel'
  ])

  const modal_window_component  = ref();
  const contacts_list_component = ref();
  const contacts_selection      = reactive(new ContactsSelectionCollection());
  const contacts_list           = reactive(new ContactsFilterCollection());
  const contacts_controller     = ContactsController;

  onBeforeMount(() => {
    contacts_list.setSearchList(contacts_controller.contacts.persons);
    contacts_list.reload();
  })

  const onModalClose = () => {
    emit('contactsToGroupCancel');
  }

  const onSearchSet = (term) => {
    contacts_selection.reset();
    contacts_list.searchIn('persons', term);
  }

  const onSearchClear = () => {
    contacts_selection.reset();
    contacts_list.reset();
    contacts_list.reload();
  }

  const onAddToGroupSubmit = async () => {
    if (await contacts_controller.addPersonsToGroup(props.group_selected, contacts_selection.getIndexKeys()) === false) {
      return;
    }

    emit('contactsToGroupSubmit');
  }

</script>
